import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import authEn from "./locales/en/auth.json";
import authFr from "./locales/fr/auth.json";
import myGarageEn from "./locales/en/dashboard/myGarage/myGarage.json";
import myGarageFr from "./locales/fr/dashboard/myGarage/myGarage.json";
import sellMyCarEn from "./locales/en/dashboard/myGarage/sellMyCar.json";
import sellMyCarFr from "./locales/fr/dashboard/myGarage/sellMyCar.json";
import generalInfoFormEn from "./locales/en/dashboard/myGarage/generalInfoForm.json";
import generalInfoFormFr from "./locales/fr/dashboard/myGarage/generalInfoForm.json";
import questionareFormEn from "./locales/en/dashboard/myGarage/questionnareForm.json";
import questionareFormFr from "./locales/fr/dashboard/myGarage/questionnareForm.json";
import specificationsEn from "./locales/en/dashboard/myGarage/specifications.json";
import specificationsFr from "./locales/fr/dashboard/myGarage/specifications.json";
import galleryEn from "./locales/en/dashboard/myGarage/gallery.json";
import galleryFr from "./locales/fr/dashboard/myGarage/gallery.json";
import carEstimateAuctionEn from "./locales/en/dashboard/myGarage/carEstimateAuction.json";
import carEstimateAuctionFr from "./locales/fr/dashboard/myGarage/carEstimateAuction.json";
import upcomingCarsEn from "./locales/en/dashboard/upcomingCars/upcomingCars.json";
import upcomingCarsFr from "./locales/fr/dashboard/upcomingCars/upcomingCars.json";
import liveAuctionEn from "./locales/en/dashboard/liveAuction/liveAuction.json";
import liveAuctionFr from "./locales/fr/dashboard/liveAuction/liveAuction.json";
import buyNowEn from "./locales/en/dashboard/buyNow/buyNow.json";
import buyNowFr from "./locales/fr/dashboard/buyNow/buyNow.json";
import carsInNegotiationEn from "./locales/en/dashboard/carsNegotiation/carsNegotiation.json";
import carsInNegotiationFr from "./locales/fr/dashboard/carsNegotiation/carsNegotiation.json";
import myOrdersEn from "./locales/en/dashboard/myOrders/myOrders.json";
import myOrdersFr from "./locales/fr/dashboard/myOrders/myOrders.json";
import vehicleAddedSuccessModalEn from "./locales/en/components/vehicleAddedSuccessModal.json";
import vehicleAddedSuccessModalFr from "./locales/fr/components/vehicleAddedSuccessModal.json";
import carContainerEn from "./locales/en/carContainer.json";
import carContainerFr from "./locales/fr/carContainer.json";
import priceIndicatorEn from "./locales/en/components/priceIndicator.json";
import priceIndicatorFr from "./locales/fr/components/priceIndicator.json";
import carAddedToSaleEn from "./locales/en/components/carAddedToSale.json";
import carAddedToSaleFr from "./locales/fr/components/carAddedToSale.json";
import bidHistoryEn from "./locales/en/components/bidHistory.json";
import bidHistoryFr from "./locales/fr/components/bidHistory.json";
import timeLeftEn from "./locales/en/components/timeLeft.json";
import timeLeftFr from "./locales/fr/components/timeLeft.json";
import saleInformationEn from "./locales/en/components/saleInformation.json";
import saleInformationFr from "./locales/fr/components/saleInformation.json";
import buyNowCarDetailReadOnlyEn from "./locales/en/dashboard/buyNow/buyNowCarDetailReadOnly.json";
import buyNowCarDetailReadOnlyFr from "./locales/fr/dashboard/buyNow/buyNowCarDetailReadOnly.json";

const resources = {
  en: {
    auth: authEn,
    myGarage: myGarageEn,
    sellMyCar: sellMyCarEn,
    generalInfoForm: generalInfoFormEn,
    questionareForm: questionareFormEn,
    specification: specificationsEn,
    gallery: galleryEn,
    carEstimateAuction: carEstimateAuctionEn,
    upcomingCars: upcomingCarsEn,
    liveAuction: liveAuctionEn,
    buyNow: buyNowEn,
    carsInNegotiation: carsInNegotiationEn,
    myOrders: myOrdersEn,
    vehicleAddedSuccessModal: vehicleAddedSuccessModalEn,
    carContainer: carContainerEn,
    priceIndicator: priceIndicatorEn,
    carAddedToSale: carAddedToSaleEn,
    bidHistory: bidHistoryEn,
    timeLeft: timeLeftEn,
    saleInformation: saleInformationEn,
    buyNowCarDetailReadOnly: buyNowCarDetailReadOnlyEn
  },
  fr: {
    auth: authFr,
    myGarage: myGarageFr,
    sellMyCar: sellMyCarFr,
    generalInfoForm: generalInfoFormFr,
    questionareForm: questionareFormFr,
    specification: specificationsFr,
    gallery: galleryFr,
    carEstimateAuction: carEstimateAuctionFr,
    upcomingCars: upcomingCarsFr,
    liveAuction: liveAuctionFr,
    buyNow: buyNowFr,
    carsInNegotiation: carsInNegotiationFr,
    myOrders: myOrdersFr,
    vehicleAddedSuccessModal: vehicleAddedSuccessModalFr,
    carContainer: carContainerFr,
    priceIndicator: priceIndicatorFr,
    carAddedToSale: carAddedToSaleFr,
    bidHistory: bidHistoryFr,
    timeLeft: timeLeftFr,
    saleInformation: saleInformationFr,
    buyNowCarDetailReadOnly: buyNowCarDetailReadOnlyFr
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    ns: [
      "header", "auth", "footer", "myGarage", "generalInfoForm", "questionareForm",
      "sidebar", "userHeader", "upcomingCars", "buyNow", "common", "liveAuction", 
      "carsInNegotiation", "specification", "carEstimateAuction", "gallery", "myOrders", 
      "signUp", "vehicleAddedSuccessModal", "priceIndicator", "carAddedToSale",
      "bidHistory", "timeLeft", "saleInformation", "buyNowCarDetailReadOnly"
    ],
    defaultNS: "header",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
